"use client";

import React, { useEffect, useRef } from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
function CategoriesGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const containerRef = useRef<HTMLDivElement>(null);
  const flareRef = useRef<HTMLDivElement>(null);
  const mousePos = useRef({
    x: -100,
    y: -100
  });
  const currentPos = useRef({
    x: -100,
    y: -100
  });
  useEffect(() => {
    let animationFrameId: number;
    const render = () => {
      currentPos.current.x += (mousePos.current.x - currentPos.current.x) * 0.15;
      currentPos.current.y += (mousePos.current.y - currentPos.current.y) * 0.15;
      if (flareRef.current) {
        flareRef.current.style.transform = `translate(${currentPos.current.x}px, ${currentPos.current.y}px)`;
      }
      animationFrameId = requestAnimationFrame(render);
    };
    render();
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    mousePos.current = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
  };
  const handleMouseLeave = () => {
    mousePos.current = {
      x: -200,
      y: -200
    };
  };
  if (loading) {
    return <div className="grid grid-cols-2 gap-[20px] md:grid-cols-6 lg:grid-cols-12">
        {[...Array(12)].map((_, i) => <div key={i} data-index={i} className="h-[250px] animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-destructive">
        <p className="font-default">Failed to load project categories. Please try again later.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p className="font-default">No craftsmanship categories found.</p>
      </div>;
  }
  return <div ref={containerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} className="relative overflow-hidden rounded-md bg-card p-[40px] shadow-xl">
      {}
      <div ref={flareRef} className="pointer-events-none absolute left-[-60px] top-[-60px] z-50 h-[120px] w-[120px] rounded-md mix-blend-multiply will-change-transform" style={{
      background: "radial-gradient(circle, rgba(184,134,11,0.15) 0%, transparent 70%)"
    }} />

      <div className="relative z-10 grid grid-cols-2 gap-[20px] md:grid-cols-6 lg:grid-cols-12">
        {posts.map((post, i) => {
        const imageUrl = post.customFields?.category_featured_image || post.featuredImage;
        const categoryName = post.customFields?.category_name || post.title;
        return <Link key={post.id} to={post.link || "/OurPortfolioPage"} data-index={i} className="group relative block h-[250px] cursor-crosshair overflow-hidden rounded-md border border-border bg-background transition-all duration-500 hover:shadow-2xl">
              {imageUrl && <img src={imageUrl} alt={categoryName} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />}
              
              {}
              <div className="absolute inset-0 bg-primary/20 transition-opacity duration-300 group-hover:bg-primary/10" />
              
              {}
              <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-primary/80 to-transparent">
                <h3 className="font-default text-lg font-semibold text-primary-foreground tracking-tight">
                  {categoryName}
                </h3>
              </div>
            </Link>;
      })}
      </div>
    </div>;
}
export default function PhotoshootCategoriesGrid() {
  const wp_query_params = {
    post_type: "photoshoot_category",
    per_page: 14,
    orderby: "title",
    order: "asc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="249664" id="featured-projects" className="bg-background text-foreground py-12 md:py-24">
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-primary mb-4">Our Craftsmanship</h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto">Explore our portfolio of high-end residential transformations across the Denver metro area.</p>
        </div>
        <PostsProvider wp_query={{
        post_type: "photoshoot_category",
        per_page: 14,
        orderby: "title",
        order: "asc"
      }}>
          <CategoriesGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}